import { useRef } from "react";

const INTERVAL =
  process.env.REACT_APP_ENV === "prod" ? 1000 * 60 * 30 : 1000 * 60 * 5;

export default () => {
  const timeRef = useRef<NodeJS.Timeout>();

  const forceRefreshToken = () => {
    if (
      typeof (window as any).AwsWafIntegration?.forceRefreshToken !== "function"
    )
      return;

    (window as any).AwsWafIntegration?.forceRefreshToken();
  };

  const updateAwsToken = async (interval: number = INTERVAL) => {
    forceRefreshToken();

    timeRef.current = setTimeout(() => {
      updateAwsToken(interval);
    }, interval);
  };

  const cancelUpdateAwsToken = () => {
    if (timeRef.current) clearTimeout(timeRef.current);
  };

  return {
    forceRefreshToken,
    updateAwsToken,
    cancelUpdateAwsToken,
  };
};
